interface IResponseError {
  error: string;
  error_description: string;
}

function instanceOfResponseError(object: any): object is IResponseError {
  return 'error' in object && 'error_description' in object;
}

const api = async <T extends unknown>(endpoint: string, { ...rest }) =>
  new Promise<T>((resolve, reject) => {
    const token =
      process.env.REACT_APP_TOKEN &&
      window.localStorage.getItem(process.env.REACT_APP_TOKEN);
    const headers: { [key: string]: string } = {
      'content-type': 'application/json'
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const config: { [key: string]: string } = {
      ...rest,
      headers: {
        ...headers,
        ...rest.headers
      }
    };

    fetch(`${process.env.REACT_APP_API_URL}/${endpoint}`, config)
      .then(async response => {
        if (!response.ok) throw response;
        return resolve(await response.json());
      })
      .catch(async (response: Error | Response | string) => {
        if (response instanceof Error) return reject(response);
        if (!(response instanceof Response)) return reject(new Error(response));

        // Special handling if Unauthorized
        if (response.status === 401) {
          return reject({ message: String(response.status) } as Error);
        }

        const body: Response | IResponseError = await response.json();
        if (instanceOfResponseError(body)) {
          return reject(new Error(body.error_description));
        }

        return reject(body);
      });
  });

export async function get<T = void>(endpoint: string, { ...rest }): Promise<T> {
  const config: { [key: string]: string } = { method: 'GET', ...rest };
  return api<T>(endpoint, config);
}

export async function post<T = void>(
  endpoint: string,
  { ...rest }
): Promise<T> {
  const config: { [key: string]: string } = { method: 'POST', ...rest };

  if (config.body && typeof config.body !== 'string') {
    config.body = JSON.stringify(config.body);
  }

  return api<T>(endpoint, config);
}
